import React, { PropTypes, PureComponent } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import { hashHistory } from 'react-router';
import { Button, BackArrow } from '../shared';
import messages from './i18n';
import statsd from '../../../lib/StatsD';
import styles from './styles.scss';

export class SignUpUserType extends PureComponent {
  static propTypes = {
    signUpSetSteps: PropTypes.func,
  };

  static onSignUpClick() {
    statsd.increment('signUp.start');

    if (window.NATIVE_INTERCOM) {
      window.intercom.logEvent('signup_started');
    } else {
      window.Intercom('trackEvent', 'signup_started'); // eslint-disable-line
    }
    if (window.facebookConnectPlugin) {
      window.facebookConnectPlugin.logEvent('TimeClockSignupProcessStarted');
    }

    if (
      window.analytics && window.analytics.track &&
      !localStorage.getItem('tc-signup-started')
    ) {
      window.analytics.track('tc-signup-started');
      localStorage.setItem('tc-signup-started', 'true');
    }

    //  appsFlyer event
    if (window.plugins && window.plugins.appsFlyer &&
      localStorage.getItem('af_signup_started') !== 'true'
    ) {
      window.plugins.appsFlyer.trackEvent('af_signup_started', {});
      localStorage.setItem('af_signup_started', 'true');
    }

    setTimeout(() => {
      hashHistory.push('/account');
    }, 1000);
  }

  constructor(props) {
    super(props);
    this.state = { gradientStyle: false, fadeOut: false };

    this.handleEmployeeClick = this.handleEmployeeClick.bind(this);
  }

  componentDidMount() {
    if (window.analytics && window.analytics.track) {
      window.analytics.track('tc-signup-user-type');
    }
  }

  addAnimationClass() {
    this.setState({ gradientStyle: true });
    this.setState({ fadeOut: true });
  }

  handleEmployeeClick() {
    this.setState({ fadeOut: true });

    if (
      window.analytics && window.analytics.track &&
      !localStorage.getItem('tc-employee-btn')
    ) {
      window.analytics.track('tc-employee-btn');
      localStorage.setItem('tc-employee-btn', 'true');
    }

    setTimeout(() => {
      hashHistory.push('/account');
    }, 1000);
  }

  render() {
    return (
      <div
        className={cn(styles.view, { [styles.animateGradient]: this.state.gradientStyle })}
      >
        <BackArrow
          styles="backArrowPositioning"
          destination="/welcome"
        />
        <div className={cn(styles.layout, { [styles.fadeAndScaleOut]: this.state.fadeOut })}>
          <div className={styles.container}>
            <div className={styles.image_container}>
              <div className={styles.caption}>
                <h3><FormattedMessage {...messages.titleRole} /></h3>
                <div className={styles.optionsContainer}>
                  <Button
                    className={styles.userType}
                    onClick={() => { SignUpUserType.onSignUpClick(); this.addAnimationClass(); }}
                    label={this.props.intl.formatMessage(messages.owner)}
                    primary
                  />
                  <Button
                    className={styles.userType}
                    onClick={() => { SignUpUserType.onSignUpClick(); this.addAnimationClass(); }}
                    label={this.props.intl.formatMessage(messages.manager)}
                    primary
                  />
                  <Button
                    className={styles.userType}
                    onClick={() => { this.handleEmployeeClick(); this.addAnimationClass(); }}
                    label={this.props.intl.formatMessage(messages.employee)}
                    primary
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(SignUpUserType);



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_user_type/index.jsx